export default function statuses(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                status: action.status,
            }
        default:
            return state;
    }
}
